// Auto-generated from /schemas/configs/ — do not edit manually.
// Regenerate with: cd schemas && just codegen

import {
    AGENTS_DEFAULTS,
    type AgentHttpConfig,
    type AgentsConfig,
    AI_SECTIONS_DEFAULTS,
    type AiSectionsConfig,
    ANALYTICS_DEFAULTS,
    type AnalyticsConfig,
    APPEARANCE_DEFAULTS,
    type AppearanceConfig,
    BACKOFFICE_DEFAULTS,
    type BackofficeConfig,
    BEHAVIOR_DEFAULTS,
    type BehaviorConfig,
    CHATGPT_DEFAULTS,
    type ChatgptConfig,
    COMPETITORS_DEFAULTS,
    CONTENT_DEFAULTS,
    CONTENT_GATING_DEFAULTS,
    type CompetitorsConfig,
    type ContentConfig,
    type ContentGatingConfig,
    CTAS_DEFAULTS,
    type CtasConfig,
    ENGAGEMENT_DEFAULTS,
    type EngagementConfig,
    type FormAssistantConfig,
    GEO_DEFAULTS,
    type GeoConfig,
    IDENTITY_DEFAULTS,
    type IdentityConfig,
    INCHAT_BOOKING_DEFAULTS,
    INTEGRATIONS_DEFAULTS,
    INTERNAL_IP_FILTER_DEFAULTS,
    type InchatBookingConfig,
    type IntegrationsConfig,
    type InternalIpFilterConfig,
    ONBOARDING_DEFAULTS,
    type OnboardingConfig,
    QUALIFICATION_DEFAULTS,
    type QualificationConfig,
    STAFF_HOLDOUT_OPT_OUT_DEFAULTS,
    type StaffHoldoutOptOutConfig,
    SYSTEM_DEFAULTS,
    type SystemConfig,
    TRACKING_STATUS_DEFAULTS,
    TRAFFIC_CONTROL_DEFAULTS,
    type TrackingStatusConfig,
    type TrafficControlConfig,
    type WebmcpConfig,
} from '../../types/configs.generated';

export const SLUG_TO_DEFAULTS: Record<string, Record<string, unknown>> = {
    agents: AGENTS_DEFAULTS as unknown as Record<string, unknown>,
    backoffice: BACKOFFICE_DEFAULTS as unknown as Record<string, unknown>,
    competitors: COMPETITORS_DEFAULTS as unknown as Record<string, unknown>,
    identity: IDENTITY_DEFAULTS as unknown as Record<string, unknown>,
    agent_http: {},
    ai_sections: AI_SECTIONS_DEFAULTS as unknown as Record<string, unknown>,
    analytics: ANALYTICS_DEFAULTS as unknown as Record<string, unknown>,
    appearance: APPEARANCE_DEFAULTS as unknown as Record<string, unknown>,
    behavior: BEHAVIOR_DEFAULTS as unknown as Record<string, unknown>,
    chatgpt: CHATGPT_DEFAULTS as unknown as Record<string, unknown>,
    content: CONTENT_DEFAULTS as unknown as Record<string, unknown>,
    content_gating: CONTENT_GATING_DEFAULTS as unknown as Record<string, unknown>,
    ctas: CTAS_DEFAULTS as unknown as Record<string, unknown>,
    engagement: ENGAGEMENT_DEFAULTS as unknown as Record<string, unknown>,
    form_assistant: {},
    geo: GEO_DEFAULTS as unknown as Record<string, unknown>,
    inchat_booking: INCHAT_BOOKING_DEFAULTS as unknown as Record<string, unknown>,
    integrations: INTEGRATIONS_DEFAULTS as unknown as Record<string, unknown>,
    onboarding: ONBOARDING_DEFAULTS as unknown as Record<string, unknown>,
    qualification: QUALIFICATION_DEFAULTS as unknown as Record<string, unknown>,
    staff_holdout_opt_out: STAFF_HOLDOUT_OPT_OUT_DEFAULTS as unknown as Record<string, unknown>,
    system: SYSTEM_DEFAULTS as unknown as Record<string, unknown>,
    tracking_status: TRACKING_STATUS_DEFAULTS as unknown as Record<string, unknown>,
    traffic_control: TRAFFIC_CONTROL_DEFAULTS as unknown as Record<string, unknown>,
    webmcp: {},
    internal_ip_filter: INTERNAL_IP_FILTER_DEFAULTS as unknown as Record<string, unknown>,
};

/** Type-level map from slug to its typed config interface. */
export interface SlugToConfigMap {
    agents: AgentsConfig;
    backoffice: BackofficeConfig;
    competitors: CompetitorsConfig;
    identity: IdentityConfig;
    agent_http: AgentHttpConfig;
    ai_sections: AiSectionsConfig;
    analytics: AnalyticsConfig;
    appearance: AppearanceConfig;
    behavior: BehaviorConfig;
    chatgpt: ChatgptConfig;
    content: ContentConfig;
    content_gating: ContentGatingConfig;
    ctas: CtasConfig;
    engagement: EngagementConfig;
    form_assistant: FormAssistantConfig;
    geo: GeoConfig;
    inchat_booking: InchatBookingConfig;
    integrations: IntegrationsConfig;
    onboarding: OnboardingConfig;
    qualification: QualificationConfig;
    staff_holdout_opt_out: StaffHoldoutOptOutConfig;
    system: SystemConfig;
    tracking_status: TrackingStatusConfig;
    traffic_control: TrafficControlConfig;
    webmcp: WebmcpConfig;
    internal_ip_filter: InternalIpFilterConfig;
}

export type ConfigSlug =
    | 'agents'
    | 'backoffice'
    | 'competitors'
    | 'identity'
    | 'agent_http'
    | 'ai_sections'
    | 'analytics'
    | 'appearance'
    | 'behavior'
    | 'chatgpt'
    | 'content'
    | 'content_gating'
    | 'ctas'
    | 'engagement'
    | 'form_assistant'
    | 'geo'
    | 'inchat_booking'
    | 'integrations'
    | 'onboarding'
    | 'qualification'
    | 'staff_holdout_opt_out'
    | 'system'
    | 'tracking_status'
    | 'traffic_control'
    | 'webmcp'
    | 'internal_ip_filter';
